export default __webpack_public_path__ + "static/media/ad_7.23095e0c.mp3";